import { render, staticRenderFns } from "./BankTemplate.vue?vue&type=template&id=f734a3ae&scoped=true&"
import script from "./BankTemplate.vue?vue&type=script&lang=js&"
export * from "./BankTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f734a3ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f734a3ae')) {
      api.createRecord('f734a3ae', component.options)
    } else {
      api.reload('f734a3ae', component.options)
    }
    module.hot.accept("./BankTemplate.vue?vue&type=template&id=f734a3ae&scoped=true&", function () {
      api.rerender('f734a3ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/BankTemplate.vue"
export default component.exports